import { Link } from 'react-router';

// Any path outside the current portal's route tree.
export function NotFound() {
  return (
    <div style={{ padding: '2rem 0' }}>
      <h1 style={{ marginBottom: '0.75rem' }}>Page not found</h1>
      <p>
        <Link to="/" style={{ color: 'var(--color-accent)' }}>Back to My Compliance Portal</Link>
      </p>
    </div>
  );
}
